import { unauthorisedRequests } from 'src/stores/device-runtime/firmware-ui';
import { is_gen_2, real_id } from '../interface_helpers';
import { get } from 'svelte/store';
import { device_auths } from 'src/stores/device-runtime/local-auth';
import type { Device } from 'src/types/Device';

/**
 * Authenticates a device by updating the device_auths store and returning relevant information.
 * @param device - The device object to authenticate.
 * @returns An array with the device, URL, HTTP method, payload, timeout, and flags.
 */
export const authenticateDevice = (device: Device) => {
	// Extract the real ID and check if the device is Gen2
	const realID = real_id(device.id);
	const isGen2 = is_gen_2(device);

	// Retrieve the unauthorised request and device authentication data
	const unauthorisedRequest = get(unauthorisedRequests)[realID];
	const deviceAuthData = get(device_auths)[realID];

	// Update the device_auths store based on the device type
	if (isGen2) {
		device_auths.update(realID, {
			auth_data: unauthorisedRequest?.responseHeaders,
			pass: deviceAuthData?.pass,
			nc: 1,
		});
	} else {
		device_auths.update(realID, {
			user: deviceAuthData?.user,
			pass: deviceAuthData?.pass,
		});
	}

	// Return an array with relevant information
	return [
		device,
		unauthorisedRequest?.url,
		'post',
		unauthorisedRequest?.payload,
		10000,
		!isGen2,
		isGen2,
	];
};
